<!-- Training Requests -->

<app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>
<div class="container-fluid px-4">
    <div class="row custom-margin my-5">
        <div class="col-md-12 col-12 p-0"
        *ngIf="questions.length > 0">
        <div class="container mb-5">
            <h2 class="text-center v4-color-white"><i style="font-size: 2rem;"
                class="pi pi-fw pi-plus-circle mx-2 v4-color-white"></i>{{"Add course requests" | translator}}</h2>
            <app-unified-trining-req *ngIf="createdTrainingHolder && unifiedblock" (closeUnified)="closeUnified()" [trainingRequest]="createdTrainingHolder" [treeFilter]="getMonthy()"></app-unified-trining-req>
            <app-dynamic-form [hidden]="unifiedblock" [questions]="questions" (sendData)="receiveData($event)"></app-dynamic-form>
            <p-messages [(value)]="messages" [enableService]="false"></p-messages>
        </div>
    </div>
</div>
</div>

<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="1" class="mb-2"></app-skelitions>

<!-- Confirm Modal -->
<p-confirmDialog [style]="{margin: '0rem 1rem'}"></p-confirmDialog>

<!-- Update Data Modal -->
<p-dialog [blockScroll]="true" [draggable]="false"header="Header" [(visible)]="updateModal" [style]="{ margin: '0rem 1rem' }">
    <ng-template pTemplate="header">
        <span class="text-xl font-bold">{{"Update classification" | translator}}</span>
    </ng-template>
    <app-dynamic-form *ngIf="updateModal" [questions]="updateQuestions"
        (sendData)="UpdateData($event)"></app-dynamic-form>
</p-dialog>


<app-footer></app-footer>